module.exports = "/img/_/_/_/assets/images/creeper/battle/epic//3.jpg?cd34b6f2e85520c9b57cc34501471c47";